var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormText',{attrs:{"title":"Успешное изменение пароля","buttonText":"На главную","buttonLink":"/"}},[_c('p',[_vm._v("Ваш пароль успешно изменен!")])])}
var staticRenderFns = []

export { render, staticRenderFns }